export function renderNetWorthBreakdown(tbody, breakdown, formatMoney) {
  if (!breakdown || breakdown.length === 0) {
    tbody.innerHTML = `
      <tr>
        <td colspan="3" class="px-4 py-3 text-sm text-stone-400 text-center">No items</td>
      </tr>
    `
    return
  }

  tbody.innerHTML = breakdown.map(item => {
    return `
      <tr class="border-b border-stone-100 hover:bg-stone-50">
        <td class="px-4 py-2 text-stone-700">${item.label}</td>
        <td class="px-4 py-2 text-right money-value">${formatMoney(item.amount)}</td>
        <td class="px-4 py-2 text-right text-stone-500">${item.percentage}%</td>
      </tr>
    `
  }).join("")
}

export function renderNetWorthInsights(container, insights) {
  if (!insights || insights.length === 0) {
    container.innerHTML = `
      <div class="rounded-lg bg-stone-50 p-4 text-sm text-stone-600">
        Enter your assets and liabilities to see personalised insights.
      </div>
    `
    return
  }

  const TYPE_STYLES = {
    success: { bg: "bg-emerald-50 border-emerald-200", text: "text-emerald-800", icon: "&#10003;" },
    warning: { bg: "bg-amber-50 border-amber-200", text: "text-amber-800", icon: "&#9888;" },
    info: { bg: "bg-blue-50 border-blue-200", text: "text-blue-800", icon: "&#8505;" }
  }

  container.innerHTML = insights.map(insight => {
    const style = TYPE_STYLES[insight.type] || TYPE_STYLES.info

    return `
      <div class="rounded-lg border ${style.bg} p-3 text-sm ${style.text} flex gap-2">
        <span class="mt-0.5 shrink-0">${style.icon}</span>
        <span>${insight.message}</span>
      </div>
    `
  }).join("")
}
